import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class FacturacionService {

  id:any

  constructor() { }
  
  getAllFacturasPago(){
    return gql`
      query getAllFacturasPago {
          facturas(where: {estado: "factura"},
          sort: "customId:DESC") {
            id
            numeroFactura
            fechaConfirmacion
            estado
            customId
          }
        }
    `;
  }

  getAllFacturas(){
    return gql`
      query getAllFacturas {
          facturas(sort: "createdAt:DESC") {
            id
            numeroFactura
            numOperacion
            contratista {
              id
              nombreComercial
              razonSocial
              cif
              direccion {
                nombre
                provincia
                localidad
                numero
                codigoPostal
              }
            }
            fechaPago
            fechaConfirmacion
            precioTotal
            licencias{
              id
            }
            numeroLicencias
            concepto
            estado
            formaPago
            iva
            baseImponible
            precioUnitario
            cliente {
              id
              nombreComercial
            }
          }
        }
    `;
  }

  getFacturaById(){
    return gql`
      query getFacturaById($id: ID!) {
          factura(id: $id) {
            id
            contratista {
              id
              razonSocial
            }
            fechaPago
            fechaConfirmacion
            precioTotal
            numeroFactura
            licencias{
              id
            }
            numeroLicencias
            concepto
            estado
            formaPago
            iva
            baseImponible
            precioUnitario
            cliente {
              id
            }
          }
        }
    `;
  }

  getFacturasByContratista(){
    return gql`
      query getFacturasByContratista($id: ID!){
        contratista(id: $id){
          facturas 
          {
            id
            concepto
            baseImponible
            precioTotal
            numeroLicencias
            iva
            estado
            fechaPago
            fechaConfirmacion
            numeroFactura
            precioUnitario
            formaPago
           cliente{
             id
             nombreComercial
           }
            
          }
        }
      }
    `;
  }

  addFactura(){
    return gql`
      mutation createFactura($input: createFacturaInput!) {
      createFactura(input: $input) {
        factura {
          id
        }
      }
    }
    `;
  }

  updateFactura(){
    return gql`
      mutation updateFactura($input: updateFacturaInput!) {
        updateFactura(input: $input) {
          factura {
            id
          }
        }
      }
    `;
  }

  deleteFactura(){
    return gql`
      mutation deleteFactura($input: deleteFacturaInput!) {
        deleteFactura(input: $input) {
          factura {
            id
          }
        }
      }
    `;
  }

  setIdFactura(id:any){
    this.id = id; 
  }

  getIdFactura(){
   let temp = this.id;
    this.clearIdFactura();
    return temp;
  }

  clearIdFactura(){
    this.id = undefined;
  }
}
